import React from "react"
import arrowBack from "@images/black-ic-arrow-back.svg"
import { GLOBAL_APPLICATION_INTERNAL_LINKS } from "../../../../../../links/internal";
import { 
    StyledReturnToBlogWrapper,
    StyledReturnToBlogLink,
    StyledReturnToBlogContainer,
    StyledReturnBackIcon,
    StyledReturnBackText
} from "./styled";

const BackToBlogButton = () => {
  return (
    <StyledReturnToBlogWrapper>
      <StyledReturnToBlogLink to={GLOBAL_APPLICATION_INTERNAL_LINKS.BLOG}>
        <StyledReturnToBlogContainer>
          <StyledReturnBackIcon src={arrowBack} />
          <StyledReturnBackText>Back to blog page</StyledReturnBackText>
        </StyledReturnToBlogContainer>
      </StyledReturnToBlogLink>
    </StyledReturnToBlogWrapper>
  )
}

export default BackToBlogButton
